// extracted by mini-css-extract-plugin
export default {"cards":"CardsList_cards__VYvKq"};